module.exports = __webpack_public_path__ + "media/components/src/assets/images/question_1-f6f128ce9a4382f1a5345213856df82f.jpg";